import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Referencia } from "src/app/models/Referencia";
import { ReferenciaDialogComponent } from "../referencia-dialog/referencia-dialog.component";
import { ReferenciasGerenciadas } from "src/app/models/ReferenciasGerenciadas";
import { UsuarioReferenciasGerenciadasService } from "src/app/services/data-services/usuario.referencias.gerenciadas.service";
import { ReferenciaGerenciada } from "src/app/models/ReferenciaGerenciada";
import { Subscription } from "rxjs";
import { ConteudoService } from "src/app/services/conteudo.service";
import { EnumTipoReferencia } from "src/app/enums/EnumTipoReferencia";

@Component({
  selector: "app-dica-estudos",
  templateUrl: "./dica-estudos.component.html",
  styleUrls: ["./dica-estudos.component.scss"],
})
export class DicaEstudosComponent implements OnInit, OnDestroy {
  public dicasEstudo!: Referencia[];
  private dicasEstudosGerenciada: ReferenciaGerenciada[];
  private subscriptions = new Array<Subscription>();

  constructor(
    public dialog: MatDialog,
    private usuarioReferenciasGerenciadasService: UsuarioReferenciasGerenciadasService,
    private conteudoService: ConteudoService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.conteudoService
        .getCarregando()
        .subscribe(() => this.conteudoSubscribe())
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }

  openDialog(referencia: Referencia): void {
    const dialogRef = this.dialog.open(ReferenciaDialogComponent, {
      data: {
        referencia: referencia,
        tipo: Referencia.identificarTipoReferencia(referencia.tipo),
      },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result: any) => {});
  }

  tipoReferencia(item: EnumTipoReferencia) {
    return Referencia.identificarTipoReferencia(item);
  }

  public async conteudoSubscribe() {
    const idLei = this.conteudoService.getIdLei();
    if (!idLei || idLei.trim() === "") {
      return;
    }

    this.dicasEstudosGerenciada = [];

    const referenciasGerenciadas =
      await this.usuarioReferenciasGerenciadasService.buscarReferenciasGerenciadasLocal();

    const referenciasGerenciada =
      referenciasGerenciadas?.find((y) => y.idLei === idLei) ??
      new ReferenciasGerenciadas();

    const referenciasFilter = referenciasGerenciada?.referencias.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (r) =>
            r.tipo === EnumTipoReferencia.DicasEstudo && r.ref === value.ref
        )
    );

    this.dicasEstudosGerenciada.push(...referenciasFilter);

    this.dicasEstudo = Referencia.referenciaParceGerenciada(
      this.dicasEstudosGerenciada
    );
  }
}
